class RouteFilter {
    static filterRoutesByDevice(routes) {
        // Check URL parameter or session storage for Isaac mode
        const urlParams = new URLSearchParams(window.location.search);
        const isIsaacMode = urlParams.get('isaac') === 'true' || 
                           sessionStorage.getItem('isaacMode') === 'true';
        
        // Store in session if detected via URL
        if (urlParams.get('isaac') === 'true') {
            sessionStorage.setItem('isaacMode', 'true');
        }

        // Only filter routes if Isaac mode is detected
        if (isIsaacMode) {
            return routes.filter(route => {
                // Allow login and password change
                if (route.path === '/login' || route.path === '/changePassword') {
                    return true;
                }
                
                // Only show maintenance form for drivers
                if (route.path === '/maintenance/form' &&
                    route.roles?.includes('driver')) {
                    return true;
                }
                
                return false;
            });
        }

        // For all other devices - show all routes
        return routes;
    }
}

export default RouteFilter;